import authRoles from '../../../auth/authRoles';
import Pricing from './Pricing';

const PricingConfig = {
  settings: {
    layout: {
      style: 'layoutMarketingV2',
      config: {
        header: {
          display: true
        },
        footer: {
          display: true
        }
      },
    },
  },
  auth: authRoles.onlyGuest,
  routes: [
    {
      path: '/pricing',
      element: <Pricing />,
    },
  ],
};

export default PricingConfig;